<app-table [config]="config"></app-table>
